<template>
  <div id="xingbieCharts" style="height: 300px; margin:0 auto"></div>
</template>

<script>
import echarts from "echarts";
export default {
  name: "pie-charts",
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    drawPie(dataset) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("xingbieCharts"));
      // 绘制图表
      myChart.setOption({
        // title: {
        //   text: "性别分布",
        //   subtext: "测试数据",
        //   x: "left"
        // },

        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          data:['男','女']
        },
        series: [
          {
            name: "性别",
            type: "pie",
            radius: "65%",
            center: ["50%", "50%"],
            data: [
              {
                value: dataset.nan,
                name: "男",
                itemStyle: {
                  normal: {
                    color: "rgb(55,122,100)"
                  }
                }
              },
              {
                value: dataset.nv,
                name: "女",
                itemStyle: {
                  normal: {
                    color: "rgb(225,98,58)"
                  }
                }
              }
            ]
          }
        ]
      });
    }
  }
};
</script>
